import React, { createContext, useContext } from 'react';
import { useUnreadMessages as useUnreadMessagesHook } from '../hooks/useUnreadMessages';

interface UnreadMessagesContextType {
  hasUnreadMessages: boolean;
  unreadCount: number;
  markAsRead: () => void;
}

const UnreadMessagesContext = createContext<UnreadMessagesContextType | null>(null);

export const UnreadMessagesProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const unreadMessages = useUnreadMessagesHook();

  return (
    <UnreadMessagesContext.Provider value={unreadMessages}>
      {children}
    </UnreadMessagesContext.Provider>
  );
};

export const useUnreadMessages = () => {
  const context = useContext(UnreadMessagesContext);

  // A missing provider would otherwise read as "0 unread" forever.
  if (!context) {
    throw new Error('useUnreadMessages must be used within UnreadMessagesProvider');
  }

  return context;
};
